export const actionTypes = {
  ADD_INSTANT_VOICE_TRAINING: 'ADD_INSTANT_VOICE_TRAINING',
  CLEAR_INSTANT_VOICE_TRAINING: 'CLEAR_INSTANT_VOICE_TRAINING',
};

const addInstantVoiceTraining = (instantVoiceTraining) => ({
  type: actionTypes.ADD_INSTANT_VOICE_TRAINING,
  instantVoiceTraining,
});

const clearInstantVoiceTraining = () => ({
  type: actionTypes.CLEAR_INSTANT_VOICE_TRAINING,
});

export { addInstantVoiceTraining, clearInstantVoiceTraining };
